import { apiAsync } from '../../../common/helpers'

export const getLocations = (companyId, pageNumber, pageSize) => {
  const params = {
    pageNumber: pageNumber || 1,
    pageSize: pageSize || 100000
  }

  return apiAsync({
    api: `external/companies/${companyId}/locations`,
    params,
    method: 'GET'
  })
}

export default getLocations
